import {UseQueryResult} from "@tanstack/react-query";
import {createContext, useContext} from "react";
import {MaterialOrderContextType} from "../types/MaterialOrderContextType";
import {MaterialOrderDetails} from "../types/MaterialOrderDetails";

enum RefetchScope {
	Files,
	Notes
}

const MaterialOrderContext = createContext<{
	order: MaterialOrderContextType,
	modifyOrder: (details: MaterialOrderDetails, pricingNeedsUpdate?: boolean, repricingButtonClicked?: boolean) => void
	refetchOrder: (scope?: RefetchScope) => Promise<UseQueryResult>
}>
	({
		order: {} as MaterialOrderContextType,
		modifyOrder: () => { },
		refetchOrder: (scope?: RefetchScope) => { return new Promise(() => { }); }
	});

const useMaterialOrder = () => useContext(MaterialOrderContext);

export { MaterialOrderContext, useMaterialOrder, RefetchScope }
